import { createSlice } from "@reduxjs/toolkit";
import { updateReviewsAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const updateReviewSlice = createSlice({
  name: "updateReview",
  initialState: data,
  reducers: {
    updateReviewSlice(state) {
      state.isLoading = true;
    },
    updateReviewSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    updateReviewSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    updateReviewSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const updateReviewHandler = (review_id:string,data:any) => async (dispatch: any) => {
  try {
    dispatch(updateReviewAction.updateReviewSlice());
    const response: any = await updateReviewsAPI(review_id,data);
    dispatch(updateReviewAction.updateReviewSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(updateReviewAction.updateReviewSliceFailure(e?.response?.data?.message));
    dispatch(updateReviewAction.updateReviewSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default updateReviewSlice.reducer;
export const updateReviewAction = updateReviewSlice.actions;
